import {Box, Card, CardContent, CardMedia, IconButton, Link} from "@mui/material";
import img1 from "../assets/images/contacts/giovanna-losco.jpg";
import img2 from "../assets/images/contacts/marialaura-deponte.jpg";
import MuiMarkdown from "../components/MuiMarkdown";
import {useEffect, useState} from "react";
import {loadMarkdown} from "../utils/loadMarkdown";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

export default function Contacts({ lang }) {
    const [contact1, setContact1] = useState("");
    const [contact2, setContact2] = useState("");

    useEffect(() => {
        loadMarkdown("contacts", lang, "contact-1").then(setContact1);
    }, [lang, contact1]);

    useEffect(() => {
        loadMarkdown("contacts", lang, "contact-2").then(setContact2);
    }, [lang, contact2]);

    return <>
        <Box gap={2} display="grid" gridTemplateColumns={{xs: "1fr", sm: "1fr 1fr"}} justifyContent="center">
            <Card
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: { xs: 515, sm: 300 }
                }}
            >
                <CardMedia
                    component="img"
                    sx={{
                        height: { xs: 200, sm: 400 },
                        objectFit: "cover",
                    }}
                    image={img1}
                    title="Giovanna Losco"
                    alt="Giovanna Losco"
                />
                <CardContent sx={{ flex: 1 }}>
                    <Box sx={{ width: "100%" }} textAlign="left">
                        <MuiMarkdown>{contact1}</MuiMarkdown>
                    </Box>
                    <Box textAlign="right">
                        <IconButton
                            component={Link}
                            href="https://www.facebook.com/p/Giovanna-Losco-Artist-Project-manager-100057312647010/"
                            target="_blank"
                            rel="noopener"
                            color="inherit"
                            sx={{
                                transition: "all 0.3s",
                                "&:hover": { color: "#3b5998" },
                            }}
                        >
                            <FacebookIcon />
                        </IconButton>
                        <IconButton
                            component={Link}
                            href="https://www.instagram.com/giovannalosco/#"
                            target="_blank"
                            rel="noopener"
                            color="inherit"
                            sx={{
                                transition: "all 0.3s",
                                "&:hover": { color: "#e1306c" },
                            }}
                        >
                            <InstagramIcon />
                        </IconButton>
                    </Box>
                </CardContent>
            </Card>
            <Card
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column" },
                    minHeight: { xs: 515, sm: 300 }
                }}
            >
                <CardMedia
                    component="img"
                    sx={{
                        height: { xs: 200, sm: 400 },
                        objectFit: "cover"
                    }}
                    image={img2}
                    title="Maria Laura Deponte"
                    alt="Maria Laura Deponte"
                />
                <CardContent sx={{ flex: 1 }}>
                    <Box sx={{ width: "100%" }} textAlign="left">
                        <MuiMarkdown>{contact2}</MuiMarkdown>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    </>
}